'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of events
 */ const Events = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M24 37.1301H80.8137V78.3163C80.8137 80.0929 79.3735 81.5331 77.5969 81.5331H27.2168C25.4402 81.5331 24 80.0929 24 78.3163V37.1301Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M24 30.2089C24 29.0058 24.9753 28.0305 26.1784 28.0305H78.6354C79.8385 28.0305 80.8137 29.0058 80.8137 30.2089V37.1317H24V30.2089Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.7638 42.8723H28.2578V50.3783H35.7638V42.8723Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M49.7032 42.8723H42.1973V50.3783H49.7032V42.8723Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M63.6432 42.8723H56.1372V50.3783H63.6432V42.8723Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M77.5826 42.8723H70.0767V50.3783H77.5826V42.8723Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.7638 55.74H28.2578V63.246H35.7638V55.74Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M49.7032 55.74H42.1973V63.246H49.7032V55.74Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M77.5826 55.74H70.0767V63.246H77.5826V55.74Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M77.5826 69.6797H70.0767V77.1857H77.5826V69.6797Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.7638 69.6797H28.2578V77.1857H35.7638V69.6797Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M63.9918 69.51H56.1372V77.3647H63.9918V69.51Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M49.7032 69.6797H42.1973V77.1857H49.7032V69.6797Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M33.04 32.3439C31.8789 32.3439 30.9385 31.4035 30.9385 30.2424V25.1016C30.9385 23.9405 31.8789 23 33.04 23C34.2011 23 35.1416 23.9405 35.1416 25.1016V30.2396C35.1416 31.4007 34.2011 32.3412 33.04 32.3412V32.3439Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M46.2407 32.3439C45.0796 32.3439 44.1392 31.4035 44.1392 30.2424V25.1016C44.1392 23.9405 45.0796 23 46.2407 23C47.4018 23 48.3423 23.9405 48.3423 25.1016V30.2396C48.3423 31.4007 47.4018 32.3412 46.2407 32.3412V32.3439Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M61.5488 25.1016C61.5488 23.9409 60.6079 23 59.4473 23C58.2866 23 57.3457 23.9409 57.3457 25.1016V30.2424C57.3457 31.403 58.2866 32.3439 59.4473 32.3439C60.6079 32.3439 61.5488 31.403 61.5488 30.2424V25.1016Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M72.6435 32.3439C71.4825 32.3439 70.542 31.4035 70.542 30.2424V25.1016C70.542 23.9405 71.4825 23 72.6435 23C73.8046 23 74.7451 23.9405 74.7451 25.1016V30.2396C74.7451 31.4007 73.8046 32.3412 72.6435 32.3412V32.3439Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M63.865 58.7773C63.865 58.7773 63.865 58.7929 63.865 58.8084C63.865 58.9329 63.6767 61.5461 60.4281 62.7283V61.095L62.3898 58.9796C62.5624 58.7929 62.5624 58.4973 62.3584 58.3107C62.1701 58.1396 61.8719 58.1396 61.6836 58.3418L60.4281 59.7106V58.3107C60.4281 58.3107 60.4281 58.3107 60.4281 58.2951C60.585 57.9374 61.3383 56.5374 63.1902 56.5374C63.2059 56.5374 63.2216 56.5374 63.2373 56.5374C63.9749 57.4085 63.865 58.7618 63.865 58.7773ZM59.4864 59.7106L58.2152 58.3418C58.0426 58.1551 57.7444 58.1396 57.5561 58.3107C57.3677 58.4818 57.3521 58.7929 57.5247 58.9796L59.4864 61.095V62.7128C56.2378 61.5306 56.0652 58.9018 56.0495 58.7929C56.0495 58.7773 56.0495 58.7773 56.0495 58.7618C56.0495 58.7462 55.9239 57.3929 56.6615 56.5219C56.6772 56.5219 56.6929 56.5219 56.7243 56.5219C58.5919 56.5219 59.3295 57.9374 59.4864 58.2796C59.4864 58.2796 59.4864 58.2796 59.4864 58.2951V59.7106ZM63.8022 55.7286C63.7238 55.6508 63.6139 55.6041 63.5041 55.5886C61.7307 55.4797 60.5693 56.3819 59.9572 57.2218C59.3452 56.3819 58.1995 55.4797 56.4104 55.5886C56.3006 55.5886 56.1907 55.6508 56.1122 55.7286C54.9666 56.8641 55.0921 58.6685 55.1078 58.8396C55.1078 58.964 55.1863 59.8506 55.767 60.8773C56.3163 61.8572 57.4776 63.1483 59.7846 63.8016C59.8003 63.8016 59.816 63.8016 59.816 63.8172C59.8317 63.8172 59.8317 63.8172 59.8474 63.8172C59.8631 63.8172 59.8631 63.8172 59.8788 63.8172C59.8945 63.8172 59.9259 63.8172 59.9415 63.8172C59.9572 63.8172 59.9886 63.8172 60.0043 63.8172C60.02 63.8172 60.02 63.8172 60.0357 63.8172C60.0514 63.8172 60.0514 63.8172 60.0671 63.8172C60.0828 63.8172 60.0985 63.8172 60.1142 63.8016C64.3986 62.6039 64.7753 59.1818 64.791 58.8551C64.8067 58.7618 64.9636 56.8952 63.8022 55.7286Z",
                fill: theme.ds5.asset.grey["700"]
            })
        ]
    });
};

exports.Events = Events;
//# sourceMappingURL=Events.cjs.map
